import * as React from "react";

import { cn } from "@/lib/utils";
import { Label } from "./label";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  description?: string;
  rightIcon?: React.ReactNode;
  rightText?: string;
  rightTextBgColor?: string;
  rightComponent?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      id,
      name,
      required,
      onChange,
      rightIcon,
      rightText,
      rightTextBgColor,
      rightComponent,
      ...props
    },
    ref
  ) => {
    return (
      <div>
        {props.label && (
          <Label htmlFor={id}>
            {props.label} {required && <span className="text-error">*</span>}
          </Label>
        )}
        <div className="relative">
          <input
            type={type}
            id={id}
            name={name}
            onChange={onChange}
            placeholder={props.placeholder || "Introduce un valor"}
            className={cn(
              "text-left flex h-10 w-full rounded-md border border-border bg-card-bg px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-text-secundary outline-none focus-visible:outline-none disabled:cursor-text disabled:opacity-50",
              rightIcon && "pr-10",
              rightText && "pr-14",
              rightComponent && "pr-14",
              className
            )}
            ref={ref}
            {...props}
          />
          {rightIcon && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center">
              {rightIcon}
            </div>
          )}
          {rightText && (
            <div
              className={`absolute text-text-primary border-y border-r border-border bg-${rightTextBgColor} dark:bg-card-bg-hover font-semibold rounded-r-md px-3  right-0 top-1/2 -translate-y-1/2 h-10 flex items-center justify-center`}
            >
              {rightText}
            </div>
          )}
          {rightComponent && (
            <div className="absolute dark:bg-card-bg-hover rounded-l-none rounded-md right-0 top-1/2 -translate-y-1/2 flex items-center justify-center">
              {rightComponent}
            </div>
          )}
        </div>
        {props.description && (
          <p className="mt-2 text-xs text-text-muted">{props.description}</p>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
